import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.invokeCopyJobLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.CopyJobLabel),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.CopyJobLabel)
    ]
})
export class InvokeCopyJobLinkedService extends LinkedService { }